"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServer = void 0;
const SERVER_TEMPLATE_NAMES = [
    'adonis',
    'apollo',
    'docusaurus',
    'ember',
    'gatsby',
    'gridsome',
    'marko',
    'mdx-deck',
    'nest',
    'next',
    'node',
    'nuxt',
    'quasar',
    'remix',
    'sapper',
    'styleguidist',
    'unibit',
    'vuepress',
];
exports.isServer = (template) => SERVER_TEMPLATE_NAMES.indexOf(template) !== -1;
